import { HistoricalSpendDTO } from "@/pages/scenario-builder/v3/api/getHistoricalSpend";
import { getMappedName } from "@/Utils/mapping-utils";

import { bcpLayerKey } from "../../../utils/bcp";
import { ALL_CHANNELS_OPTION, ChannelOption } from "../types";

export const channelsByBCPKey = (historicalSpendsDTO: HistoricalSpendDTO[]) => {
  return historicalSpendsDTO?.reduce(
    (acc, spend) => {
      if (spend.is_node_channel_active && spend.marketing_spend.spend > 0) {
        let formattedChannel;
        if (spend.marketing_spend.channel === ALL_CHANNELS_OPTION.value) {
          formattedChannel = ALL_CHANNELS_OPTION.label;
        } else {
          formattedChannel =
            getMappedName(spend.marketing_spend.channel) || spend.marketing_spend.channel;
        }

        if (
          !formattedChannel ||
          formattedChannel.trim() === "" ||
          formattedChannel?.includes("Add Media Channel") ||
          formattedChannel?.includes("Add Channel")
        ) {
          return acc;
        }
        if (!acc[bcpLayerKey(spend.marketing_spend.marketing_spend_node)]) {
          acc[bcpLayerKey(spend.marketing_spend.marketing_spend_node)] = [];
        }

        acc[bcpLayerKey(spend.marketing_spend.marketing_spend_node)]?.push({
          key: spend.marketing_spend.channel,
          label: formattedChannel,
          disabled: false,
        });
      }
      return acc;
    },
    {} as Record<string, ChannelOption[]>
  );
};
